<template>
    <v-card rounded="lg" class="booking-card">
        <template v-if="loading">
            <v-card-text class="d-flex align-center justify-center pa-8">
                <v-progress-circular color="primary" indeterminate size="80" width="7" />
            </v-card-text>
        </template>
        <template v-else>
            <v-card-title class="text-wrap pa-0">
                <div v-if="showThankyou" class="d-flex flex-column align-center">
                    <v-sheet rounded="circle" color="primary" width="60" height="60" class="d-flex align-center justify-center my-4">
                        <v-icon icon="mdi-check" size="40" />
                    </v-sheet>
                    <div :class="titleCssClasses">{{ title }}</div>
                </div>
                <div v-else>
                    <div :class="titleCssClasses">{{ title }}</div>
                </div>
            </v-card-title>
            <v-card-text class="pt-4 pb-6 px-0">
                <slot name="textInnerPrepend" />
                <div v-if="showHasBooking" class="d-flex align-center mb-4">
                    <v-icon icon="mdi-check-circle-outline" size="20" color="primary" />
                    <span class="text-h6 font-weight-regular line-height-1 ml-2">
                        {{ t('booking.resources.bookingSuccessTitle') }}
                    </span>
                </div>
                <div data-id="bookingCardDescription" class="text-h6 font-weight-regular" :class="textCssClasses">
                    <span v-html="description" />
                </div>
            </v-card-text>

            <slot />
        </template>
    </v-card>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { Props, setupBookingCard } from './setupBookingCard';

const props = defineProps<Props>();
const { t } = useI18n();
const { titleCssClasses, textCssClasses } = setupBookingCard(props);
</script>

<style lang="scss">
.booking-card {
    overflow: visible;
}
</style>
